module.exports = __webpack_public_path__ + "media/images/icons/filled/qq-square-44d6cda0fa18ba8a336563ae734f7029.svg";